"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidatorFunctions = exports.DateUtils = exports.ComparisonBuilder = exports.memorySize = exports.formatNumber = exports.getAsPages = exports.inList = exports.filterMapByValue = exports.filterMapByKey = exports.mapRemap = exports.mapGroupBy = exports.sleep = exports.makeLink = exports.removeProps = exports.pickProps = exports.movingAvg = exports.stdDev = exports.avg = exports.sum = exports.max = exports.min = exports.asMapValue = exports.asMap = exports.remap = exports.groupBy = exports.sortMapByValue = exports.sortMapByKey = void 0;
const ComparisonBuilder_1 = __importDefault(require("./ComparisonBuilder"));
exports.ComparisonBuilder = ComparisonBuilder_1.default;
const DateUtils = __importStar(require("./date-utils"));
exports.DateUtils = DateUtils;
const Validator = __importStar(require("./validator"));
exports.ValidatorFunctions = Validator;
function sortMapByKey(map, sorter) {
    var result = {};
    var temp = Object.entries(map);
    temp.sort((a, b) => sorter(a[0], b[0]));
    temp.forEach(([a, b]) => result[a] = b);
    return result;
}
exports.sortMapByKey = sortMapByKey;
function sortMapByValue(map, sorter) {
    var result = {};
    var temp = Object.entries(map);
    temp.sort((a, b) => sorter(a[1], b[1]));
    temp.forEach(([a, b]) => result[a] = b);
    return result;
}
exports.sortMapByValue = sortMapByValue;
function groupBy(list, grouper) {
    let result = {};
    for (var i in list) {
        let element = list[i];
        let key = grouper(element);
        if (key in result) {
            result[key].push(element);
            continue;
        }
        result[key] = [element];
    }
    return result;
}
exports.groupBy = groupBy;
function remap(map, mapper) {
    var result = {};
    Object.entries(map).forEach(([k, v]) => result[k] = mapper(v));
    return result;
}
exports.remap = remap;
function asMap(list, keyMapper) {
    return asMapValue(list, keyMapper, (t) => t);
}
exports.asMap = asMap;
function asMapValue(list, keyMapper, valueMapper) {
    var result = {};
    list.forEach(i => result[keyMapper(i)] = valueMapper(i));
    return result;
}
exports.asMapValue = asMapValue;
function min(list, getter) {
    let result = null;
    for (var i in list) {
        let element = list[i];
        let n = getter(element);
        if (n === null)
            continue;
        if (result === null) {
            result = n;
            continue;
        }
        result = Math.min(n, result);
    }
    return result;
}
exports.min = min;
function max(list, getter) {
    let result = null;
    for (var i in list) {
        let element = list[i];
        let n = getter(element);
        if (n === null)
            continue;
        if (result === null) {
            result = n;
            continue;
        }
        result = Math.max(n, result);
    }
    return result;
}
exports.max = max;
function sum(list, getter) {
    let result = 0;
    for (var i in list) {
        let element = list[i];
        let n = getter(element);
        result += n !== null && n !== void 0 ? n : 0;
    }
    return result;
}
exports.sum = sum;
function avg(list, getter) {
    if (list.length == 0)
        return 0;
    let result = sum(list, getter);
    return result / list.length;
}
exports.avg = avg;
function stdDev(list, getter) {
    if (list.length < 2)
        return null;
    const mean = avg(list, getter);
    let sum = 0;
    for (var i in list) {
        let element = list[i];
        let n = getter(element);
        sum += Math.pow(n - mean, 2);
    }
    return Math.sqrt(sum / (list.length - 1));
}
exports.stdDev = stdDev;
function movingAvg(list, getX, getY, period = 7) {
    const result = [];
    let sumY = 0;
    for (let i = 0; i < list.length; i++) {
        sumY += getY(list[i]);
        if (i >= period - 1) {
            const x = getX(list[i]);
            const avgY = sumY / period;
            sumY -= getY(list[i - (period - 1)]);
            result.push({ x: x, y: avgY });
        }
    }
    return result;
}
exports.movingAvg = movingAvg;
function pickProps(obj, props) {
    var result = {};
    props.forEach(a => result[a] = obj[a]);
    return result;
}
exports.pickProps = pickProps;
function removeProps(obj, exclude) {
    const shallowCopy = Object.assign({}, obj);
    for (const prop of exclude) {
        delete shallowCopy[prop];
    }
    return shallowCopy;
}
exports.removeProps = removeProps;
function makeLink(str) {
    if (str == null)
        return "";
    return str.toLowerCase()
        .replace(/[àáâãª]/g, "a")
        .replace(/[éê]/g, "e")
        .replace(/[í]/g, "i")
        .replace(/[óôõº]/g, "o")
        .replace(/[ûúü]/g, "u")
        .replace(/[ç]/g, "c")
        .replace(/[^a-z0-9 -]/g, "")
        .replace(/[ -]+/g, "-");
}
exports.makeLink = makeLink;
;
async function sleep(time) {
    return await (new Promise((ok) => {
        setTimeout(ok, time);
    }));
}
exports.sleep = sleep;
function mapGroupBy(list, grouper) {
    let result = new Map();
    for (var i in list) {
        let element = list[i];
        let key = grouper(element);
        if (result.has(key)) {
            result.get(key).push(element);
            continue;
        }
        result.set(key, [element]);
    }
    return result;
}
exports.mapGroupBy = mapGroupBy;
function mapRemap(map, mapper) {
    var result = new Map();
    [...map.entries()].forEach(([k, v]) => result.set(k, mapper(v)));
    return result;
}
exports.mapRemap = mapRemap;
function filterMapByKey(map, filter) {
    var result = new Map();
    [...map.entries()].forEach(([k, v]) => {
        if (filter(k))
            result.set(k, v);
    });
    return result;
}
exports.filterMapByKey = filterMapByKey;
function filterMapByValue(map, filter) {
    var result = new Map();
    [...map.entries()].forEach(([k, v]) => {
        if (filter(v))
            result.set(k, v);
    });
    return result;
}
exports.filterMapByValue = filterMapByValue;
function inList(list, item) {
    if (!list)
        return false;
    const itemList = typeof list == 'string' ? list.split(/ *, */g) : list;
    return itemList.includes(item);
}
exports.inList = inList;
function getAsPages(items, itemsPerPage) {
    const totalPages = Math.ceil(items.length / itemsPerPage);
    const pages = [];
    for (let i = 0; i < totalPages; i++) {
        const startIndex = i * itemsPerPage;
        const endIndex = startIndex + itemsPerPage;
        const currentPageItems = items.slice(startIndex, endIndex);
        pages.push({
            page: i + 1,
            items: currentPageItems
        });
    }
    return pages;
}
exports.getAsPages = getAsPages;
function formatNumber(n, decimalPlaces = 1) {
    return n.toLocaleString('pt-BR', {
        maximumFractionDigits: decimalPlaces,
    });
}
exports.formatNumber = formatNumber;
function memorySize(n) {
    if (n < 1024)
        return n + " bytes";
    if ((n /= 1024) < 1024)
        return formatNumber(n) + " KB";
    if ((n /= 1024) < 1024)
        return formatNumber(n) + " MB";
    return formatNumber(n / 1024) + " GB";
}
exports.memorySize = memorySize;
__exportStar(require("./TaskManager"), exports);
__exportStar(require("./rate-limiter"), exports);
//# sourceMappingURL=index.js.map